<template>
    <v-dialog
        v-model="displayDialog"
        width="575"
        :persistent="true"
    >
        <v-card dark>
            <v-card-title
                class="headline"
                primary-title
            >
                <h2 class="dialog-confirm-title">{{ titleAsData || title }}</h2>
            </v-card-title>
            <v-card-text>
                {{ textAsData || text }}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-row justify="end" class="dialog-confirm-buttons">
                    <v-col cols="3">
                        <v-btn
                            @click="cancel"
                        >
                            {{ textDecline }}
                        </v-btn>
                    </v-col>
                    <v-col cols="3">
                        <v-btn
                            color="info"
                            @click="confirm"
                        >
                            {{ textConfirm }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    components: {},
    props: {
        text: {
            type: String,
            required: false,
            default: '',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        textConfirm: {
            type: String,
            required: false,
            default: function() {
                return this.$t('partials.dialog_confirm.default_confirm');
            },
        },
        textDecline: {
            type: String,
            required: false,
            default: function() {
                return this.$t('partials.dialog_confirm.default_cancel');
            },
        },
        callbackConfirm: {
            type: Function,
            required: false,
            default (){
                return ()=>{return Promise.resolve()};
            }
        },
        callbackDecline: {
            type: Function,
            required: false,
            default (){
                return ()=>{return Promise.resolve()};
            }
        },
    },
    data() {
        return {
            displayDialog: false,
            resolve: null,
            titleAsData: null,
            textAsData: null,
        };
    },
    computed: {},
    mounted() {},
    methods: {
        open (title=null, text=null){
            this.titleAsData = title;
            this.textAsData = text;
            this.displayDialog = true;
            return new Promise((resolve) => {
                this.resolve = resolve;
            });
        },
        async confirm (){
            await this.callbackConfirm();
            this.resolve(true);
            this.displayDialog = false;
        },
        async cancel (){
            await this.callbackDecline();
            this.resolve(false);
            this.displayDialog = false;
        },
    },
};

</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Partials/dialog-confirm.vue